import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';

import config from 'config/common';
import lib from 'lib/commons';
import ModalGiftSelect from './ModalGiftSelect';

Modal.setAppElement('#root');

const ModalSelect = ({
	modalStatus,
	closeModal,
	selectData,
	doClaim,
	isClaiming,
	specialExchangeInfo,
	totalCanClaim,
	currCanClaim,
	accumulation,
}) => {
	const [prize, setPrize] = useState(null);

	const afterOpenModal = () => {};

	const selfClose = (event) => {
		event.preventDefault();
		closeModal();
	};

	const isClaimed = (item) => {
		const count = specialExchangeInfo[`${item?.id}`]?.count
			? specialExchangeInfo[`${item?.id}`]?.count
			: 0;
		const checkLimit =
			typeof item?.limit === 'number' ? item?.limit - count : '';

		return typeof item?.limit === 'number' && checkLimit == 0;
	};

	const hanldeClaims = (event, item, available) => {
		event.preventDefault();

		if (isClaiming) {
			return;
		}

		if (item?.round_required && available < 1) {
			return false;
		}

		doClaim(selectData?.stage, item?.id, (res) => {
			setPrize(item);
		});
	};

	const isSpecial = selectData?.rewards.find((item) => item?.round_required);

	return (
		<Modal
			isOpen={modalStatus}
			onAfterOpen={afterOpenModal}
			onRequestClose={selfClose}
			contentLabel="Example Modal"
			portalClassName="ReactModalPortal"
			overlayClassName=""
			className={`animated fadeInDown faster modal-select${
				isSpecial && isSpecial?.id ? ' special' : ''
			}`}
		>
			<h2>
				<img src="/images/select-gift.png" alt="" className="title-modal" />
			</h2>
			<div className="modal-description">
				<div className="popup-select__desc">
					Vui lòng chọn 1 trong {selectData?.rewards.length} món quà bên dưới
				</div>
				<div className="popup-select__items">
					{selectData?.rewards.length > 0 &&
						selectData?.rewards.map((item, index) => {
							let currentLimit = 0;
							let realLimit = 0;
							let available = 0;
							let history = 0;
							let nextHistory = 0;
							if (item?.round_required) {
								history = specialExchangeInfo[`${item?.id}`]?.count || 0;
								currentLimit = totalCanClaim / item?.round_required;
								realLimit = Math.min(item?.limit, currentLimit);
								available = realLimit - history;
								nextHistory = history + 1 + Math.floor(available);
							}

							return (
								<div
									className={`popup-select__item ${
										isClaimed(item) || (item?.round_required && available < 1)
											? 'claimed'
											: ''
									}${isSpecial && isSpecial?.id ? ' special' : ''}`}
									key={index}
								>
									<div className="popup-select__item--image">
										<img src={item?.image} />
									</div>
									<div className="popup-select__item--name">{item?.desc}</div>
									{/* {selectData?.stage == 200 && item?.limit && (
                  <a href="https://fo4.garena.vn/danh-sach-icons-duc-brazil-2023/" target="_blank" className="popup-select__link">
                    Xem danh sách cầu thủ
                  </a>
                )} */}
									<a
										href="#"
										className="btn"
										onClick={(e) => hanldeClaims(e, item, available)}
									>
										Chọn
									</a>
									{item?.limit && (
										<div className="popup-select__item--note">
											{item?.limit && item?.round_required === null && (
												<>
													Bạn chỉ được chọn quà này tối đa {item?.limit} lần (Đã
													chọn {specialExchangeInfo[`${item?.id}`]?.count || 0}/
													{item?.limit})
												</>
											)}
											{item?.limit &&
												item?.round_required !== null &&
												currentLimit < item?.limit && (
													<>
														<strong>Quà đặc biệt</strong> <br />
														Bạn sẽ có thêm 1 lượt chọn ở mốc điểm{' '}
														{/* {lib.formatNumber(
															(selectData?.stage *
																((Math.floor(
																	currCanClaim / item?.round_required
																) +
																	1) *
																	item?.round_required -
																	1) +
																selectData?.stage) *
																(history + 1)
														)} */}
														{nextHistory < item?.limit
															? lib.formatNumber(
																	nextHistory *
																		selectData?.stage *
																		item?.round_required
															  )
															: lib.formatNumber(
																	item?.limit *
																		selectData?.stage *
																		item?.round_required
															  )}
														. <br />
														Đang có {lib.formatNumber(accumulation) ||
															0} điểm. <br />
														Bạn đang có {Math.floor(available)} lượt chọn.{' '}
														<br /> Đã chọn&nbsp;
														{specialExchangeInfo[`${item?.id}`]?.count || 0}/
														{item?.limit}
													</>
												)}
											{item?.limit &&
												item?.round_required !== null &&
												currentLimit >= item?.limit && (
													<>
														Bạn đang có {Math.floor(available)} lượt chọn.{' '}
														<br />
														Bạn chỉ được chọn quà này tối đa {
															item?.limit
														} lần <br />
														(Đã chọn{' '}
														{specialExchangeInfo[`${item?.id}`]?.count || 0}/
														{item?.limit})
													</>
												)}
										</div>
									)}
								</div>
							);
						})}
				</div>
			</div>
			{!!prize && (
				<ModalGiftSelect
					modalStatus={!!prize}
					closeModal={() => {
						setPrize(null);
						closeModal();
					}}
					gift={prize}
				/>
			)}
		</Modal>
	);
};

export default ModalSelect;
